import { env } from './.env';

export const environment = {
  production: true,
  version: env['npm_package_version'],
  // Informar a URL da API para o ERP
  apiUrl: 'https://erp-api.chronosinfo.com.br',
  controlaAssinatura: true,
  pagSeguroPublicKey:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
  tokenWhitelistedDomains: [new RegExp('64.31.26.6:8084')],
  tokenBlacklistedRoutes: [new RegExp('/oauth/token')],
  configuracaoThema: {
    name: 'Chronos',
    logo: 'assets/images/chronos/logo.png',
    favicon: 'assets/images/chronos/favicon.ico',
    logoLogin: 'assets/images/chronos/logo_login.png',
    site: 'https://chronosinfo.com.br/',
    theme: 'theme-orange',
    layout: 'layout-b',
    copyright: 'ChronosInfo',
    social: {
      instagram: 'https://www.instagram.com/chronos.info/',
      youTube: 'https://www.youtube.com/@chronosinfo.manager',
      telegram: 'https://t.me/+557999985542?text',
      whatsap: 'https://wa.me/557999985542?text',
    },
  },
};
